import { cardAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, } from "@chakra-ui/react";
import shadows from "../../../../theme/foundations/generated/shadows";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(cardAnatomy.keys);
export const baseStyle = definePartsStyle(({ hasContainerPadding }) => ({
    container: {
        padding: hasContainerPadding ? "1rem" : 0,
        borderRadius: "none",
        boxShadow: shadows.large,
    },
    header: {
        padding: "none",
        marginBottom: "1rem",
    },
    body: {
        padding: "none",
    },
    footer: {
        padding: "none",
        marginTop: "1rem",
    },
}));
const variants = {
    green: {
        container: {
            background: "semantic.brand.secondary-dimmed",
        },
    },
    blue: {
        container: {
            background: "semantic.brand.tertiary-dimmed",
        },
    },
    yellow: {
        container: {
            background: "semantic.brand.quaternary-dimmed",
        },
    },
    salmon: {
        container: {
            background: "semantic.brand.quinary-dimmed",
        },
    },
    white: {
        container: {
            background: "semantic.surface.1",
        },
    },
};
export default defineMultiStyleConfig({
    baseStyle,
    variants,
});
//# sourceMappingURL=Card.default.js.map